import { Icon, IconProps } from './Icon';

interface SoloIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const SoloIcon = ({ color = '#BDC9EE', gradient, ...props }: SoloIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7109 22.1601C28.0233 22.1601 32.3299 17.8535 32.3299 12.5411C32.3299 7.22864 28.0233 2.92206 22.7109 2.92206C17.3984 2.92206 13.0918 7.22864 13.0918 12.5411C13.0918 17.8535 17.3984 22.1601 22.7109 22.1601ZM39.8696 33.7342C40.8118 36.0089 41.2967 38.4469 41.2967 40.9091H22.5478L3.79883 40.9091C3.79883 38.4469 4.28378 36.0089 5.22601 33.7342C6.16823 31.4594 7.54927 29.3926 9.29027 27.6516C11.0313 25.9106 13.0981 24.5295 15.3729 23.5873C17.6476 22.6451 20.0856 22.1601 22.5478 22.1601C25.0099 22.1601 27.448 22.6451 29.7227 23.5873C31.9974 24.5295 34.0643 25.9106 35.8053 27.6516C37.5463 29.3926 38.9273 31.4594 39.8696 33.7342Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
